import {
  BackButton,
  MoveBackButton,
} from '@/features/v2/components/buttons/MoveBackButton';
import {
  MoveForwardButton,
  NextButton,
} from '@/features/v2/components/buttons/MoveForwardButton';
import { SubmitStageButton } from '@/features/v2/components/buttons/SubmitStageButton';
import { useStepper } from '@/features/v2/lib/stepper';
import { VehicleDamageSchema } from '@/features/v2/vehicle-damage/stepsSchema';

import { useFormContext } from 'react-hook-form';

export const StepForm = ({
  id,
  onSubmit,
  children,
  nextButton,
  prevButton,
  submitButton,
  isLastStep,
  handleSubmit,
  nextStageOnSubmit,
}: {
  id?: string;
  onSubmit?: (e?: React.BaseSyntheticEvent) => Promise<void>;
  handleSubmit?: () => void;
  children: React.ReactNode;
  nextButton?: NextButton;
  prevButton?: BackButton;
  submitButton?: {
    label?: string;
    isDisabledProp?: boolean;
    isLoading?: boolean;
    uniqTestId?: string;
  };
  isLastStep?: boolean;
  nextStageOnSubmit?: boolean;
}) => {
  const { step, isDeadEnd, innerStep } = useStepper();
  const showSubmitButton = isLastStep || isDeadEnd;

  const { watch } = useFormContext();

  const backButton = !!VehicleDamageSchema[step]?.backButton?.(
    innerStep,
    watch()
  );
  return (
    <form onSubmit={onSubmit} id={id}>
      <div className={'mb-5 w-full space-y-5 overflow-hidden'}>{children}</div>
      <div
        className={
          'flex w-full flex-col-reverse items-center gap-x-5 gap-y-4 md:flex-row md:justify-end'
        }
      >
        {backButton && <MoveBackButton {...prevButton} />}
        <MoveForwardButton
          hidden={showSubmitButton}
          handleSubmit={handleSubmit}
          {...nextButton}
        />
        <SubmitStageButton
          hidden={!showSubmitButton}
          nextStageOnSubmit={nextStageOnSubmit}
          {...submitButton}
        />
      </div>
    </form>
  );
};
